export const GET_CMS = "GET_CMS";
export const GET_CONTENT_CATEGORIES = "GET_CONTENT_CATEGORIES";
export const GET_CMS_DETAIL = "GET_CMS_DETAIL";
export const GET_APPLICATIONS = "GET_APPLICATIONS";